import { render, staticRenderFns } from "./OnusNew.vue?vue&type=template&id=9e551676&scoped=true&"
import script from "./OnusNew.vue?vue&type=script&lang=js&"
export * from "./OnusNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e551676",
  null
  
)

export default component.exports